<template>
  <div id="home-container">
    <!-- Homepage wrapper including Theme, Country, Itinerary entries -->
    <div id="home">
      <div id="home-description" v-html="exploreSiteDescription"></div>
      <ExploreTheme></ExploreTheme>
      <ExploreCountry></ExploreCountry>
      <ExploreItinerary></ExploreItinerary>
      <!-- Partner logos displayed at the bottom of the page -->
      <div id="partners" v-if="partners.length > 0">
        <div class="partner" v-for="partner in partners" :key="partner.title">
          <a
            class="partner-link"
            v-if="partner.url.length > 0"
            :href="partner.url"
            target="_blank"
          >
            <div class="partner-logo-container">
              <img class="partner-logo" :src="partner.logo" />
            </div>
          </a>
          <span class="partner-title">
            {{ partner.title }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ExploreTheme from "../components/ExploreTheme.vue";
import ExploreCountry from "../components/ExploreCountry.vue";
import ExploreItinerary from "../components/ExploreItinerary.vue";
import language from "../mixins/language.js";
import homepageTexts from "../mixins/homepageTexts.js";
export default {
  name: "HomePage",
  title: "Home | Explore with MWNF",
  mixins: [language, homepageTexts],
  components: {
    ExploreTheme: ExploreTheme,
    ExploreCountry: ExploreCountry,
    ExploreItinerary: ExploreItinerary,
  },
  data() {
    return {
      exploreSiteDescription: "",
      partners: [],
    };
  },
  methods: {
    getPartners: function () {
      let url = `${process.env.VUE_APP_API_ENDPOINT}/featured-partnership?h=1`;
      return axios({ method: "GET", url: url }).then(
        (result) => {
          let results = result.data;
          let partners = [];
          for (let i = 0; i < results.length; i++) {
            let details = {};
            details.title = this.returnValueInLanguage(
              "en",
              results[i].details
            ).title;
            details.logo = results[i].logo;
            details.url = this.returnValueInLanguage(
              "en",
              results[i].details
            ).url;
            partners.push(details);
          }
          this.partners = partners;
        },
        (error) => {
          console.error(error);
        }
      );
    },
  },
  mounted() {
    this.getTexts("exploreSiteDescription", "Home-Description");
    this.getPartners();
    this.$nextTick(() => {
      let name = this.$route.hash.slice(1);
      if (this.$route.hash) {
        let a = document.getElementsByName(name);
        a = a[0];
        a && a.scrollIntoView();
      }
    });
  },
};
</script>

<style scoped lang="scss">
#home-container {
  width: 100%;
}

#home-description {
  padding: 40px;
}
#home-description,
#home-description :deep(*) {
  @include texts;
  @include font-size-4;
  color: $medium-dark-grey;
}
.italic {
  font-style: italic;
}
#home-description :deep(a) {
  color: $medium-dark-grey;
  text-decoration: underline;
}

#partners {
  @include flex-center;
  flex-wrap: wrap;
  padding: 40px;
}
.partner {
  @include flex-center;
  flex-direction: column;
  margin: 0 20px;
}
.partner-logo-container {
  height: 125px;
  width: 85px;
}
.partner-logo {
  @include image-scale;
  object-fit: contain;
  object-position: bottom;
}
.partner-title {
  text-align: center;
  margin-top: 5px;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .partner {
    align-self: flex-end;
  }
  .partner-logo-container {
    height: auto;
  }
}

@media only screen and (max-width: 1199px) {
  #home-description,
  #home-description :deep(*) {
    @include texts;
    @include font-size-5;
    color: $medium-dark-grey;
  }
}

@media only screen and (max-width: 499px) {
  #home-description,
  #home-description :deep(*) {
    @include font-size-6;
  }
}
</style>
